import React from 'react';

import { VisualiserHolder, VisualiserVideo } from './YatMintFlow.style';

export function VisualizerSection({ src }: { src: string }) {
    return (
        <VisualiserHolder>
            <VisualiserVideo autoPlay muted webkit-playsinline="true" playsInline loop src={src} />
        </VisualiserHolder>
    );
}
